<template>
	<van-skeleton avatar :row="1" v-if="List.length==0">{{List.length}}</van-skeleton>
    <div  v-else class="votesrecord-body">
        <List v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad">
              <div class="votesrecord-body-item" v-for="(item,index) in List" :key="index">
              	<div class="votesrecord-body-item-info">
              		<div class="votesrecord-body-item-info-name">
              			<div>NO.{{index+1}}</div>
              			<div>{{item.name}}</div>
              		</div>
              		<div class="votesrecord-body-item-info-new">
              			<div v-if="item.rank>0">排名：<span>{{item.rank}}</span></div>
              			<div>票数：<span>{{item.votes}}</span></div>
              		</div>
              	</div>
              	<div class="votesrecord-body-item-content">
              		<div class="votesrecord-body-item-content-title">{{item.title}}</div>
        			     <img :src="item.imgurl" slot="icon" alt="" @click="gotouch(item)">
              	</div>
              </div>
        </List>
        <van-popup v-model="show" closeable :style="{ height: '100%',width: '100%' }" :close-icon="require('assets/img/common/colse.svg')">
            <video
              id="video" 
              class="video" 
              :src="mediaurl"
              controls = "true"
              :poster="imgurl"
              preload="auto" 
              webkit-playsinline="true" 
              playsinline="true"
              x-webkit-airplay="allow" 
              x5-video-player-type="h5"
              x5-video-player-fullscreen="true"
              x5-video-orientation="portraint"
              style="object-fit:fill">
            </video> 
        </van-popup>
    </div>
</template>
<script>
    import {List,Popup} from 'vant'
    import './index.less'

    export default {
        name: "myvotes",
        components: {
            List,
            vanPopup:Popup
        },
        data() {
            return {
                page: 1,
                List: [],
                finished: false,
                loading: false,
                show:false,
                imgurl:'',
                mediaurl:''
            }
        },
        methods: {
            showVideo: function (e) {
                window.location.href = e;
            },
            onLoad() {
                this.getList()
            },
            getList() {
                if (this.finished) return;
                this.$api.user.myvotes({page: this.page}).then((res) => {
                    if (res.status * 1 === 200) {
                    	console.log(res.data.list)
                        this.List = this.List.concat(res.data.list)
                        if (res.data.pages * 1 > this.page) {
                            this.page++
                        } else {
                            this.finished = true
                        }
                    }
                    this.loading = false
                })
            },
            gotouch(item) {
                this.show = true
                this.imgurl = item.imgurl
                this.mediaurl = item.mediaurl
                // var myVideo=document.getElementById("video");
                // myVideo.play();
                // if (myVideo.paused) 
                //   myVideo.play(); 
                // else 
                //   myVideo.pause(); 
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.getList();
            })
        }
    }
</script>